// extracted by mini-css-extract-plugin
module.exports = {"kitF":"kitF_kitF__AVrab"};